//service
import useSWR from "swr";
import axiosInstance from "Api";

export const API_ENDPOINT = {
  GET_SCHOOLS: {
    url: "schools",
    method: "get",
  },
  GET_SCHOOLS_LIST: {
    url: "schools-list",
    method: "get",
  },
  GET_ABSENCE_CODES: {
    url: "absence-codes-list",
    method: "get",
  },
  GET_GROUPS: {
    url: "groups-list",
    method: "get",
  },
  GET_ORGANIZATION_USERS: {
    url: "organization-users-list",
    method: "get",
  },
  GET_ORGANIZATIONS: {
    url: "organizations-list",
    method: "get",
  },
};

const WizardService = {
  getSchools: (communityId, isCoordinator) => {
    const url = isCoordinator
      ? `${API_ENDPOINT.GET_SCHOOLS.url}?iCommunityId=${communityId}`
      : `${API_ENDPOINT.GET_SCHOOLS_LIST.url}?iCommunityId=${communityId}`;

    return axiosInstance.get(url);
  },

  getAbsenceCodes: (communityId) =>
    axiosInstance.get(
      `${API_ENDPOINT.GET_ABSENCE_CODES.url}?iCommunityId=${communityId}`
    ),

  getGroups: (communityId) =>
    axiosInstance.get(`${API_ENDPOINT.GET_GROUPS.url}?iCommunityId=${communityId}`),

  getOrganizationUsers: (communityId) =>
    axiosInstance.get(
      `${API_ENDPOINT.GET_ORGANIZATION_USERS.url}?iCommunityId=${communityId}`
    ),

  getOrganizations: () =>
    axiosInstance.get(API_ENDPOINT.GET_ORGANIZATIONS.url),
};

export const useSchools = (communityId, isCoordinator) =>
  useSWR(
    communityId ? ["schools", communityId, isCoordinator] : null,
    ([, id, coordinator]) => WizardService.getSchools(id, coordinator)
  );

export const useAbsenceCodes = (communityId) =>
  useSWR(
    communityId ? ["absence-codes-list?iCommunityId=", communityId] : null,
    ([, id]) => WizardService.getAbsenceCodes(id)
  );

export const useGroups = (communityId) =>
  useSWR(
    communityId ? ["groups", communityId] : null,
    ([, id]) => WizardService.getGroups(id)
  );

export const useOrganizationUsers = (communityId) =>
  useSWR(
    communityId ? ["organization-users", communityId] : null,
    ([, id]) => WizardService.getOrganizationUsers(id)
  );

export const useOrganizations = () =>
  useSWR("organizations-list", () => WizardService.getOrganizations());

export default WizardService;